import { z } from "zod";

const emailAlreadyUsedThumbaError = z.object({
  code: z.literal("invalid"),
  cause: z.literal("email already exists"),
});

type EmailAlreadyUsedThumbaError = z.infer<typeof emailAlreadyUsedThumbaError>;

export const isEmailAlreadyUsedThumbaError = (error: unknown): error is EmailAlreadyUsedThumbaError =>
  emailAlreadyUsedThumbaError.safeParse(error).success;

const thumbaErrorSchema = z.union([
  emailAlreadyUsedThumbaError,
  emailAlreadyUsedThumbaError, // When new error is added, please replace this first.
]);

export type ThumbaError = z.infer<typeof thumbaErrorSchema>;
